// ----------------------------------------------------------------------------
// Nombre del Programa : Graficas
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de las graficas de analitics
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Se modificaron etiquetas 20/AGO/2024
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import { GraficasPros } from '../../interfaces/analiticosInterfaces';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

export const Graficos = ({ datosDia, datosHora, datosFecha }: GraficasPros) => {
  const dias = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sabado',
  ];
  const colors = ['#BB1F20', '#3F4F9E', '#7A9D33'];
  const [opcionesDia, setOpcionesDia] = useState<any>();
  const [opcionesHora, setOpcionesHora] = useState<any>();
  const [opcionesFecha, setOpcionesFecha] = useState<any>();

  useEffect(() => {
    if (datosDia && datosHora && datosFecha) cargarGraficas();
  }, [datosDia, datosHora, datosFecha]);

  const formatoHora = (hora) => {
    const intHora = parseInt(hora);
    let res = hora;
    if (intHora < 10) {
      res = `0${hora}`;
    }
    res += `:00`;
    return res;
  };
  const cargarGraficas = () => {
    let datosGrafica: any = datosDia.map((datos) => {
      return {
        label: datos.evento,
        data: datos.datos
          .sort((a, b) => {
            const an = parseInt(a.dimension);
            const bn = parseInt(b.dimension);
            if (an > bn) return 1;
            if (an < bn) return -1;
            return 0;
          })
          .map((d) => {
            return {
              ...d,
              dimension: dias[d.dimension],
            };
          }),
      };
    });
    let categories: any[] = [];
    datosGrafica.forEach((d) => {
      d.data.forEach((d2: any) => {
        const dimension = d2.dimension;
        if (categories.indexOf(dimension) === -1) {
          categories.push(dimension);
        }
      });
    });
    datosGrafica.forEach((d) => {
      d.data = categories.map((c) => {
        return {
          dimension: c,
          conteo: d.data.find((c2) => c2.dimension === c)?.conteo || 0,
        };
      });
    });
    const opcionesGraficaDia = {
      chart: {
        type: 'spline',
      },
      title: {
        text: 'Estadísticas por día',
      },
      xAxis: {
        categories,
      },
      yAxis: {
        title: {
          text: 'Eventos',
        },
      },
      series: datosGrafica.map((dia, i) => {
        return {
          name: dia.label,
          color: colors[i],
          data: dia.data.map((d) => [d.dimension, d.conteo]),
        };
      }),
    };
    setOpcionesDia(opcionesGraficaDia);

    datosGrafica = datosHora.map((datos) => {
      return {
        label: datos.evento,
        data: datos.datos
          .sort((a, b) => {
            const an = parseInt(a.dimension);
            const bn = parseInt(b.dimension);
            if (an > bn) return 1;
            if (an < bn) return -1;
            return 0;
          })
          .map((d) => {
            return {
              ...d,
              dimension: formatoHora(d.dimension),
            };
          }),
      };
    });
    categories = [];
    datosGrafica.forEach((d) => {
      d.data.forEach((d2: any) => {
        const dimension = d2.dimension;
        if (categories.indexOf(dimension) === -1) {
          categories.push(dimension);
        }
      });
    });

    datosGrafica.forEach((d) => {
      d.data = categories.map((c) => {
        return {
          dimension: c,
          conteo: d.data.find((c2) => c2.dimension === c)?.conteo || 0,
        };
      });
    });
    const opcionesGraficaHora = {
      chart: {
        type: 'spline',
      },
      title: {
        text: 'Estadísticas por hora',
      },
      yAxis: {
        title: {
          text: 'Eventos',
        },
      },
      xAxis: {
        categories,
      },
      series: datosGrafica.map((dia, i) => {
        return {
          name: dia.label,
          color: colors[i],
          data: dia.data.map((d) => [d.dimension, d.conteo]),
        };
      }),
    };
    setOpcionesHora(opcionesGraficaHora);

    datosGrafica = datosFecha.map((datos) => {
      return {
        label: datos.evento,
        data: datos.datos
          .map((v) => {
            const year = v.dimension.substring(0, 4);
            const month = v.dimension.substring(4, 6);
            const day = v.dimension.substring(6, 8);
            return {
              dimension: new Date(`${year}-${month}-${day}`),
              conteo: v.conteo,
            };
          })
          .sort((a, b) => {
            const an = a.dimension;
            const bn = b.dimension;
            if (an > bn) return 1;
            if (an < bn) return -1;
            return 0;
          }),
      };
    });
    categories = [];
    datosGrafica.forEach((d) => {
      d.data.forEach((d2: any) => {
        const dimension = d2.dimension.toUTCString();
        if (!categories.some((c) => c.toUTCString() === dimension)) {
          categories.push(d2.dimension);
        }
      });
    });

    datosGrafica.forEach((d) => {
      d.data = categories.map((c) => {
        return {
          dimension: c,
          conteo:
            d.data.find((c2) => c2.dimension.toUTCString() === c.toUTCString())
              ?.conteo || 0,
        };
      });
    });

    const opcionesGraficaFecha = {
      chart: {
        type: 'spline',
      },
      tooltip: {
        formatter() {
          const values = this as any;
          return `${values.x.toUTCString().split(' 00')[0]
            }<br><b>${Highcharts.numberFormat(values.y, 0)}</b>`;
        },
      },
      title: {
        text: 'Estadísticas por fecha',
      },
      yAxis: {
        title: {
          text: 'Eventos',
        },
      },
      xAxis: {
        type: 'datetime',
        categories,
        labels: {
          formatter: (e) => {
            return Highcharts.dateFormat('%d/%m/%Y', e.value);
          },
        },
      },
      // xAxis: {
      //   categories: datosFecha.map((vista) => vista.evento),
      // },
      series: datosGrafica.map((dia, i) => {
        return {
          name: dia.label,
          color: colors[i],
          data: dia.data.map((d) => [d.dimension, d.conteo]),
        };
      }),
    };
    setOpcionesFecha(opcionesGraficaFecha);
  };
  return (
    <>
      <Row className="mt-3">
        <Col>
          <HighchartsReact highcharts={Highcharts} options={opcionesFecha} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col md={6}>
          <HighchartsReact highcharts={Highcharts} options={opcionesDia} />
        </Col>
        <Col md={6}>
          <HighchartsReact highcharts={Highcharts} options={opcionesHora} />
        </Col>
      </Row>
    </>
  );
};
